/**
 * Namespace tuple only — written in Phase 4, never edited again (plan §3.4).
 */
export const ROOT_KEY = ['meridian'] as const;
export type RootKey = typeof ROOT_KEY;
